document.addEventListener('DOMContentLoaded', () => {
    const cmsToolbar = document.querySelector('#cms-top')
    if (cmsToolbar) {
        const mainHeader = document.querySelector('.main-header')
        if (mainHeader) {
            mainHeader.style.top = '46px'
        }
    }
})
